import React from "react";
import { Routes, Route } from "react-router-dom";
import SendReportVersionRouter from "./versions/version-router";
import { SendReportCreate } from "./versions/v1/pages/send-report-create";
import { ArchiveSummary } from "./archive/pages/archive-summary";

export const SendReportRouter: React.FC = () => {

  return (
    <Routes>
      <Route path="archived/*" element={<ArchiveSummary/>} />
      <Route
        path="active/*"
        element={<SendReportVersionRouter />}
      />
      <Route
        path="draft/*"
        element={<SendReportCreate/>}
      />
    </Routes>
  );
};
